/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResourcesSegment } from '../../models/paged-resources-segment';

export interface GetSegments$Params {
  'Active-Tenant-Identifier': string;
  page?: number;
  size?: number;

/**
 * Sort results by field. Supported fields: [segmentName]
 */
  sortField?: string;
  sort?: string;
}

export function getSegments(http: HttpClient, rootUrl: string, params: GetSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResourcesSegment>> {
  const rb = new RequestBuilder(rootUrl, getSegments.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sortField', params.sortField, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResourcesSegment>;
    })
  );
}

getSegments.PATH = '/segments';
